const supportedInputTypes = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  DATE_TIME: 'DATETIME',
  TOGGLE: 'TOGGLE',
  NONE: 'NONE'
};

export default supportedInputTypes;